import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Row, Col } from "antd";
import { isNil } from "lodash";
import { toaster } from "Helpers/toaster";
import { Button, TextInput } from "@life-line-lab/components-react";
import { listDeliveryUpdates } from "Services/deliver-updates.services";
import DeliveryUpdates from "Components/order-management/parcel-order-tab-contents/delivery-updates/delivery-updates";
import "./track-n-trace.scss";
import { useQuery, useRecaptchaV3 } from "Hooks/index";

const TrackNTrace = () => {
  const history = useHistory();
  const query = useQuery();
  const urlTrackingNumber = query.get("trackingNumber");
  const { t } = useTranslation();
  const [inputTracking, setInputTracking] = useState<any>({
    trackingNumber: urlTrackingNumber || "",
  });
  const [deliveryUpdates, setDeliveryUpdates] = useState<any>(null);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const executeRecaptcha = useRecaptchaV3();

  const onBack = () => {
    history.goBack();
  };

  useEffect(() => {
    if (urlTrackingNumber) {
      handleListDeliveryUpdates(inputTracking);
    }
  }, []);

  //TODO: TO FIX: Typing is not smooth
  const handleFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputTracking({ ...inputTracking, [e.target.name]: e.target.value });
  };

  const handleListDeliveryUpdates = async (input) => {
    setIsLoading && setIsLoading(true);
    const recaptchaToken = await executeRecaptcha("delivery_update");
    const responseData = await listDeliveryUpdates(
      { trackingNumber: input.trackingNumber },
      { sortBy: "createdAt", mode: "ASC" },
      null,
      recaptchaToken,
    );

    if (!isNil(responseData)) {
      setDeliveryUpdates(responseData);
    } else {
      toaster("error", "Cannot get delivery updates");
    }

    setIsLoading && setIsLoading(false);
  };

  return (
    <React.Fragment>
      <Helmet>TRACK AND TRACE</Helmet>
      <div className="track-n-trace">
        <div className="tnt-container">
          <div className="tnt-header-container">
            {!urlTrackingNumber && (
              <div className="tnt-back">
                <ArrowLeftOutlined
                  onClick={() => {
                    onBack();
                  }}
                  className="cursor-pointer back-action left"
                />
              </div>
            )}
            <img
              alt={t("alt.logo")}
              src="/assets/images/banner_logo.png"
              className="tnt-logo"
            />
          </div>
          <div className="tnt-content-container">
            <Row gutter={[0, 16]}>
              <Col span={24} className="tnt-content-center">
                {t("txt.trackAndTrace")}
              </Col>
              <Col span={24}>
                <TextInput
                  isReadonly={!!urlTrackingNumber}
                  isRequired={true}
                  value={inputTracking.trackingNumber}
                  name="trackingNumber"
                  onChange={handleFieldChange}
                  placeholder={t("txt.enterTrackingNumber")}
                />
              </Col>
              {!urlTrackingNumber && (
                <Col span={24}>
                  <div className="tnt-btn-container">
                    <Button
                      className="track-n-trace--button"
                      type="primary"
                      label="Find parcel"
                      size="large"
                      onClick={() => {
                        handleListDeliveryUpdates(inputTracking);
                      }}
                    />
                  </div>
                </Col>
              )}
            </Row>
            <Row style={{ width: "100%" }}>
              <Col span={24}>
                {deliveryUpdates && (
                  <DeliveryUpdates
                    deliveryUpdatesInformation={deliveryUpdates}
                    isLoading={isLoading}
                  />
                )}
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default TrackNTrace;
